/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputDirection
 */
export interface InputDirection {
    /**
     * 
     * @type {string}
     * @memberof InputDirection
     */
    coordinates: string;
    /**
     * 
     * @type {string}
     * @memberof InputDirection
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InputDirection
     */
    type: string;
}

/**
 * Check if a given object implements the InputDirection interface.
 */
export function instanceOfInputDirection(value: object): boolean {
    if (!('coordinates' in value)) return false;
    if (!('name' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function InputDirectionFromJSON(json: any): InputDirection {
    return InputDirectionFromJSONTyped(json, false);
}

export function InputDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputDirection {
    if (json == null) {
        return json;
    }
    return {
        
        'coordinates': json['coordinates'],
        'name': json['name'],
        'type': json['type'],
    };
}

export function InputDirectionToJSON(value?: InputDirection | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'coordinates': value['coordinates'],
        'name': value['name'],
        'type': value['type'],
    };
}

